import React, { useState, useEffect } from "react";
import { Container, Typography, Box, Grid, IconButton } from "@mui/material";
import Navbar from "./Navbar";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter"; // Use for X
import TripOriginIcon from "@mui/icons-material/TripOrigin"; // Placeholder for TripAdvisor
import RestaurantIcon from "@mui/icons-material/Restaurant"; // Placeholder for OpenTable

const LandingPage = () => {
  const styles = {
    fontFamily: "'Brilon', sans-serif",
  };

  // Array of image URLs
  const images = [
    `${process.env.PUBLIC_URL}/assets/images/IMG_5457.jpg`,
    `${process.env.PUBLIC_URL}/assets/images/cajun-shrimp-and-grits-7.jpg`,
    `${process.env.PUBLIC_URL}/assets/images/AdobeStock_324739203_Preview.jpeg`,
    `${process.env.PUBLIC_URL}/assets/images/old-fashioned-classic-recipe.webp`,
    `${process.env.PUBLIC_URL}/assets/images/pexels-elletakesphotos-2696064.jpg`,
    `${process.env.PUBLIC_URL}/assets/images/pexels-life-of-pix-67468.jpg`,
    `${process.env.PUBLIC_URL}/assets/images/pexels-pixabay-262978.jpg`,
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length); // Cycle through images
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [images.length]);

  return (
    <>
      <Navbar />
      <Container>
        {/* Social Media Icons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <IconButton
            href="https://www.facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#4267B2" }} // Facebook blue
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#E1306C" }} // Instagram pink
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            href="https://www.twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#1DA1F2" }} // Twitter blue
          >
            <TwitterIcon />
          </IconButton>
          <IconButton
            href="https://www.tripadvisor.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#34E0A1" }} // TripAdvisor green
          >
            <TripOriginIcon />
          </IconButton>
          <IconButton
            href="https://www.opentable.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#D91E18" }} // OpenTable red
          >
            <RestaurantIcon />
          </IconButton>
        </Box>
        {/* Replace the h1 title with the logo */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/sugarcanelogo.png`} // Path to your logo
            alt="The Sugarcane Cafe Logo"
            style={{
              maxWidth: "200%",
              height: "auto",
              maxHeight: "400px", // Optional: Limit the height of the logo
            }}
          />
        </Box>
        <Typography variant="h5" align="center" paragraph style={styles}>
          Experience the best dining experience with our exquisite menu and cozy
          atmosphere.
        </Typography>
        <Box
          sx={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={images[currentImageIndex]}
            alt={`Slide ${currentImageIndex + 1}`}
            style={{
              width: "100%",
              maxWidth: "800px",
              height: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          />
        </Box>
        {/* Locator Map and Contact Info */}
        <Grid container spacing={4} sx={{ marginTop: "40px" }}>
          {/* Locator Map */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                border: "2px solid #4caf50",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <iframe
                title="Locator Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d144.9537353153169!3d-37.81627974202171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf577d8b3c3d3e3e3!2sGeneric%20Cafe!5e0!3m2!1sen!2sus!4v1614111234567!5m2!1sen!2sus"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </Box>
          </Grid>
          {/* Contact Info */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontFamily: "'Brilon', sans-serif" }}
              >
                Contact Us
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Address:</strong> 123 Sugarcane Lane, Foodie City, FC
                12345
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Phone:</strong> (123) 456-7890
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Email:</strong> contact@sugarcanecafe.com
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Hours:</strong>
                <br />
                Monday - Friday: 8:00 AM - 10:00 PM
                <br />
                Saturday - Sunday: 9:00 AM - 11:00 PM
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      {/* Footer */}
      <Box
        component="footer"
        sx={{
          backgroundColor: "#4caf50", // Green background
          color: "white", // White text
          padding: "20px 0", // Padding for spacing
          marginTop: "40px", // Space above the footer
          textAlign: "center", // Center-align text
        }}
      >
        <Typography variant="body2" sx={{ fontFamily: "'Brilon', sans-serif" }}>
          © {new Date().getFullYear()} The Sugarcane Cafe. All rights reserved.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <IconButton
            href="https://www.facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "white" }}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "white" }}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            href="https://www.twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "white" }}
          >
            <TwitterIcon />
          </IconButton>
        </Box>
      </Box>
    </>
  );
};

export default LandingPage;
